import React from 'react';

const RangeSlider = ({ value, min, max, onChange }) => {
    let percent = (value - min) / (max-min) * 100;
    if (percent < 0) percent = 0;
    if (percent > 100) percent = 100;

    return (
      <div className="range-slider">
        <input id="range" type="range"
          value={value}
          min={min}
          max={max}
          step="1"
          onChange={onChange}
        />
        <div className="range-slider-value"
            style={{ 
                    left: percent + '%',
                    transform: 'translate(-' + percent + '%, 0)'
                 }}
        >
            <div>
                {value}
            </div>
        </div>
      </div>
    )
}

export default RangeSlider;


// WEBPACK FOOTER //
// ./src/components/RangeSlider.js